<template>
  <v-container fluid>
    <router-view
      :loading="loading"
      :loadingOffline="loadingOffline"
      :news="news"
      :meta="meta"
      :newsOffline="newsOffline"
      :metaOffline="newsOfflineMeta"
      @news:search="onSearch"
      @news:pagination="onPagination"
    ></router-view>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'NewsHome',
  components: {},
  data() {
    return {
      isInitialized: false,
      loading: true,
      loadingOffline: true,
    }
  },
  watch:{
    $route(_, from) {
      if (from.name === 'SingleNews') {
        this.clearStore()
        this.clearStoreOffline()
        this.fetch()
        this.fetchOffline()
      }
    }
  },
  computed: {
    ...mapGetters('news', { news: 'getArray', meta: 'getMeta' }),
    ...mapGetters('newsOffline', { newsOffline: 'getArray', newsOfflineMeta: 'getMeta' }),
  },
  methods: {
    ...mapMutations('news', {
      addNewsFilter: 'ADD_FILTER',
      setNewsOrder: 'SET_SORT',
      clearNewsFilters: 'CLEAR_FILTERS',
      clearStore:'CLEAR'
    }),
    ...mapMutations('newsOffline', {
      addNewsFilterOffline: 'ADD_FILTER',
      setNewsOrderOffline: 'SET_SORT',
      clearNewsFiltersOffline: 'CLEAR_FILTERS',
      clearStoreOffline:'CLEAR'
    }),
    ...mapActions('news', { getNews: 'readCollection' }),
    ...mapActions('newsOffline', { getNewsOffline: 'readCollection' }),

    onSearch(value) {
      this.addNewsFilter({ key: 'news_title', value })
      this.addNewsFilterOffline({ key: 'news_title', value })
      this.addNewsFilter({ key: 'pageNumber', value:1 })
      this.addNewsFilterOffline({ key: 'pageNumber', value:1 })
      this.fetch()
      this.fetchOffline()
    },
    onPagination(value) {
      this.addNewsFilter({ key: 'pageNumber', value })
      this.fetch()
    },
    onPaginationOffline(value) {
      this.addNewsFilterOffline({ key: 'pageNumber', value })
      this.fetchOffline()
    },
    async fetch() {
      this.loading = true
      this.addNewsFilter({ key: 'news_publish', value: 'online' })
      await this.getNews()
      this.loading = false
    },
   async fetchOffline() {
      this.loadingOffline = true
      this.addNewsFilterOffline({ key: 'news_publish', value: 'offline' })
      await this.getNewsOffline()
      this.loadingOffline = false
    },
  },
  async created() {
    this.addNewsFilter({ key: 'pageSize', value: 10 })
    this.setNewsOrder({ key: 'created_at', value: 'DESC' })
    this.addNewsFilterOffline({ key: 'pageSize', value: 10 })
    this.setNewsOrderOffline({ key: 'created_at', value: 'DESC' })
    await this.fetch()
    await this.fetchOffline()
    this.isInitialized = true
  },
}
</script>

<style lang="less" scoped></style>
